import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

const LabelServicios = (props) => {
  const { Servicios = [] } = props;
  const classes = useStyles();
  
  return (
    <div className={classes.root}>
      {Servicios.map((item, index) =>
        <Chip
          variant="outlined"
          color="primary"
          key={index}
          label={item.Descripcion}
        />
      )}
    </div>
  );
};
export default LabelServicios;
